import React from 'react';
import PropTypes from 'prop-types';

class TitleSearchInput extends React.Component {
    handleChange = e => {
        if (this.props.handleChange) this.props.handleChange(e);
    };

    render() {

        return (
            <span>
                        <input
                            ref={input => (this.titleSearchInput = input)}
                            type="text"
                            name="title-task-filter"
                            onChange={this.handleChange}
                            className="filter-input-box"
                            value={this.props.defaultValue}
                            placeholder={this.props.placeholderText}
                            autoFocus
                        />
             </span>
        );
    }
}

TitleSearchInput.propTypes = {
    handleChange:       PropTypes.func.isRequired,
    defaultValue:       PropTypes.string,
    placeholderText:    PropTypes.string
};

export default TitleSearchInput;



// WEBPACK FOOTER //
// ./src/containers/_shared/Fields/TitleSearchInput.js